<template>
  <section>
    <div class="card rounded mb-5 podft-filter" v-if="showBack">
      <div class="card-header p-3 min-h-45px h-45px collapsible cursor-pointer rotate collapsed" data-bs-toggle="collapse" data-bs-target="#filter">
        <h5 class="card-title text-gray-700 fs-5 m-0 ms-3 text-gray-700 fw-bold">Поиск</h5>
        <div class="card-toolbar rotate-180 m-0 me-3">
          <i class="ki-duotone ki-down fs-3"></i>
        </div>
      </div>
      <div id="filter" class="collapse">
        <div class="card-body p-5">
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                ИИН/БИН <small class="fw-bold">"Страхователь"</small>
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.iin" type="text" class="form-control" name="filter.iin" id="filter.iin" placeholder="ИИН/БИН"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Номер договора
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.global" type="text" class="form-control" name="filter.global" id="filter.global" placeholder="Номер договора"/>
              </div>
            </div>
            <div class="col-xl-2 col-md-6" v-if="!filter.isGlobal">
              <div class="text-gray-600 mb-2 fs-8">
                Внутренний номер
              </div>
              <div class="input-group input-group-sm mb-5">
                <input type="text" v-model="filter.one_c" class="form-control" name="filter.one_c" id="filter.one_c" placeholder="Внутренний номер"/>
              </div>
            </div>
            <div class="col-xl-4 col-md-6" v-if="!filter.isGlobal">
              <div class="text-gray-600 mb-2 fs-8">
                Дата создания договора
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.start" type="date" class="form-control" name="filter.start" id="filter.start"/>
                <span class="input-group-text">-</span>
                <input v-model="filter.end" type="date" class="form-control" name="filter.end" id="filter.end"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                ФИО <small class="fw-bold">"Менеджер"</small>
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.manager" type="text" class="form-control" name="filter.manager" id="filter.manager" placeholder="ФИО"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                ФИО <small class="fw-bold">"Инициатор"</small>
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.creator" type="text" class="form-control" name="filter.creator" id="filter.creator" placeholder="ФИО"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                APC
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.apc" type="text" class="form-control" name="filter.apc" id="filter.apc" placeholder="APC"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Статус
              </div>
              <div class="input-group input-group-sm mb-5">
                <select v-if="!isSupport" v-model="filter.status" class="form-select" name="filter.status" id="filter.status">
                  <option value="">Все</option>
                  <option value="0">Новый</option>
                  <option value="1">Оформлен</option>
                  <option value="2">Ошибка</option>
                  <option value="5">Ошибка оператора</option>
                  <option value="7">В обработке</option>
                  <option value="8">Отправлен на отмену</option>
                </select>
                <select v-else v-model="filter.status" class="form-select" name="filter.status" id="filter.status">
                  <option value="">Все</option>
                  <option value="0">Новый</option>
                  <option value="1">Отработан</option>
                  <option value="2">Ошибка</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-between p-3">
          <button type="button" class="btn btn-light-warning btn-sm" @click="changeFilter(true)">Сбросить</button>
<!--          <switch-box-field v-model="filter.isGlobal" placeholder="Поиск по 1С" id="searchByGlobal"/>-->
          <div>
            <button v-if="!isSupport" type="button" :disabled="exportLoader" class="btn btn-light-warning btn-sm me-2" @click="exportExcel()">{{ exportLoader ? 'Загрузка...' : 'Экспорт' }}</button>
            <button type="button" class="btn btn-primary btn-sm" @click="changeFilter()">Применить</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// import SwitchBoxField from '@/components/Fields/SwitchBoxField';
import axios from "axios";

export default {
  name: 'PolicyFilter',
  // components: {SwitchBoxField},
  props: {
    filter: null,
    isSupport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showBack: true,
      exportLoader: false
    }
  },
  methods: {
    changeFilter(isClear = false) {
      if (isClear) {
        const filter = {
          isGlobal: false,
          isShort: true,
          manager:  '',
          creator:  '',
          global:   '',
          status:   '',
          one_c:    '',
          start:    '',
          end:      '',
          iin:      '',
          apc:      this.$user.apc ?? ''
        }
        this.$emit('changeFilter', filter)
      } else {
        this.$emit('changeFilter', true)
      }
    },
    exportExcel() {
      this.exportLoader = true;
      if (!this.filter.start && this.filter.end) this.filter.start = this.filter.end;
      if (!this.filter.end && this.filter.start) this.filter.end = this.filter.start;
      axios.get('/api/policy/export', { responseType: 'blob', params: this.filter })
          .then(async (res) => {
            const contentType = res.headers['content-type'];

            if (contentType && contentType.includes('application/json')) {
              const text = await res.data.text();
              const json = JSON.parse(text);
              this.$notifyWarning({ message: json.message });
            } else {
              const url = window.URL.createObjectURL(res.data);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'policy.csv');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          })
          .catch(err => {
            this.$notifyError({ message: err.message });
          })
          .finally(() => {
            this.exportLoader = false;
          });
    }
  }
}
</script>

<style></style>